/* eslint-disable react/no-multi-comp */
import {Link} from "react-router-dom";
import ProductRatingStars from "./ProductRatingStars";
import PropTypes from "prop-types";
import React from "react";

const ProductRating = (props) => {
  const {
    average,
    count,
    forGrid,
    fromClearancePage,
    fromProductDetailsModal,
    previewSwapping,
    productUrl
  } = props;

  if (!count > 0) {
    return null;
  }

  const scrollToRatingsAndReviews = () => {
    document.getElementById("ratings-and-reviews-container").scrollIntoView();

    const btn = document.querySelector("#ratings-and-reviews-container span.expand-btn");

    if (btn) {
      btn.click();
    }
  };

  const displayCount = () => {
    if (forGrid || previewSwapping) {
      return (
        <span>
          {`(${count})`}
        </span>
      );
    }

    if (fromProductDetailsModal) {
      return (
        /* eslint-disable react/jsx-no-bind */
        <Link
          to={{
            "hash": "#ratings-and-reviews-container",
            "pathname": productUrl,
            "state": {
              fromClearancePage,
              "prevPath": window.location.pathname
            }
          }}
        >
          {`${count} ratings`}
        </Link>
        /* eslint-enable react/jsx-no-bind */
      );
    }

    return (
      /* eslint-disable react/jsx-no-bind */
      <a onClick={scrollToRatingsAndReviews}>
        {`${count} ratings`}
      </a>
      /* eslint-enable react/jsx-no-bind */
    );
  };

  return (
    <div className="product-rating">
      <ProductRatingStars
        averageRating={average}
        forGrid={forGrid}
      />
      {displayCount()}
    </div>
  );
};

ProductRating.defaultProps = {
  "average": 0,
  "count": 0,
  "forGrid": false,
  "fromClearancePage": false,
  "fromProductDetailsModal": false,
  "history": {},
  "previewSwapping": false,
  "productUrl": ""
};

ProductRating.propTypes = {
  "average": PropTypes.number,
  "count": PropTypes.number,
  "forGrid": PropTypes.bool,
  "fromClearancePage": PropTypes.bool,
  "fromProductDetailsModal": PropTypes.bool,
  "history": PropTypes.object,
  "previewSwapping": PropTypes.bool,
  "productUrl": PropTypes.string
};

export default ProductRating;
